import { gql } from "@apollo/client";
export const CONFIG_ELEMENT_FRAGMENT = gql`
  fragment configElement on ConfigElement {
    createdAt
    id
    description
    runtime
    type
    value
    writeOnly
  }
`;

export const GET_ENVIRONMENT = gql`
  query GetEnvironment($stackId: ID!) {
    stack(id: $stackId) {
      id
      attachedContexts {
        id
        contextDescription
        contextId
        contextLabels
        contextName
        isAutoattached
        priority
        config {
          ...configElement
        }
      }
      canWrite
      name
      runtimeConfig {
        context {
          contextId
          contextName
        }
        element {
          ...configElement
        }
        stackDependency {
          id
          dependsOnStack {
            id
            name
          }
        }
      }
      trackedCommit {
        url
        hash
      }
      trackedBranchHead {
        url
        hash
      }
      trackedCommitSetBy
    }
  }
  ${CONFIG_ELEMENT_FRAGMENT}
`;

export const ADD_STACK_CONFIG = gql`
  mutation AddStackConfig($stackId: ID!, $input: ConfigInput!) {
    stackConfigAdd(stack: $stackId, config: $input) {
      id
      type
    }
  }
`;

export const UPDATE_STACK_CONFIG = gql`
  mutation UpdateStackConfig($stackId: ID!, $input: ConfigInput!) {
    stackConfigAdd(stack: $stackId, config: $input) {
      id
      type
    }
  }
`;
